module.exports = __webpack_public_path__ + "static/media/coins.55002e66.png";